(function () {
  var savedQueries = {};
  var pendingScrollToPartType = false;
  var SHEET_MQ = '(max-width: 1023.98px)';

  function isBrandFilter(filter) {
    return filter && filter.dataset.filterKind === 'brand';
  }

  function getBrandList(filter) {
    return filter ? filter.querySelector('.filter__brand-list') : null;
  }

  function getSelectedBrandCheckboxes(filter) {
    var list = getBrandList(filter);
    if (!list) return [];

    return Array.from(list.querySelectorAll('input[type="checkbox"]:checked'));
  }

  function applyBrandSelectionCollapse(filter) {
    if (!isBrandFilter(filter)) return;

    var list = getBrandList(filter);
    if (!list) return;

    var selected = getSelectedBrandCheckboxes(filter);
    var searchWrap = filter.querySelector('.filter__brand-search-wrap');
    var emptyMsg = filter.querySelector('.js-brand-filter-empty');
    var hasSelection = selected.length > 0;

    filter.classList.toggle('filter--brand-collapsed', hasSelection);

    if (searchWrap) {
      searchWrap.hidden = hasSelection;
    }

    if (emptyMsg) {
      emptyMsg.hidden = true;
    }

    list.querySelectorAll('li').forEach(function (li) {
      if (!hasSelection) return;

      var checkbox = li.querySelector('input[type="checkbox"]');
      var isSelected = checkbox && checkbox.checked;

      if (isSelected) {
        li.removeAttribute('hidden');
      } else {
        li.setAttribute('hidden', '');
      }
    });
  }

  function filterBrandList(input) {
    var filter = input.closest('.filter');
    if (!filter) return;

    if (getSelectedBrandCheckboxes(filter).length > 0) {
      applyBrandSelectionCollapse(filter);
      return;
    }

    var list = getBrandList(filter);
    if (!list) return;

    var query = String(input.value || '').trim().toLowerCase();
    var emptyMsg = filter.querySelector('.js-brand-filter-empty');
    var visibleCount = 0;

    list.querySelectorAll('li').forEach(function (li) {
      var name = (li.getAttribute('data-brand-name') || '').trim();
      var matches = !query || name.indexOf(query) !== -1;

      if (matches) {
        li.removeAttribute('hidden');
        visibleCount += 1;
      } else {
        li.setAttribute('hidden', '');
      }
    });

    if (emptyMsg) {
      emptyMsg.hidden = visibleCount > 0 || !query;
    }
  }

  function scrollToPartTypeFilter() {
    var partTypeFilter = document.querySelector('.filter[data-filter-kind="part-type"]');
    if (!partTypeFilter) return;

    var details = partTypeFilter.closest('details');
    if (details && !details.open) {
      details.open = true;
    }

    var drawerContent = document.querySelector('.facets .drawer__content');
    var isMobileDrawer = window.matchMedia(SHEET_MQ).matches;

    window.requestAnimationFrame(function () {
      if (isMobileDrawer && drawerContent) {
        var containerRect = drawerContent.getBoundingClientRect();
        var filterRect = partTypeFilter.getBoundingClientRect();
        var scrollTop = drawerContent.scrollTop + (filterRect.top - containerRect.top) - 12;

        drawerContent.scrollTo({
          top: Math.max(0, scrollTop),
          behavior: 'smooth'
        });
        return;
      }

      partTypeFilter.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest'
      });
    });
  }

  function bindBrandCheckbox(filter) {
    var list = getBrandList(filter);
    if (!list || list.dataset.brandCheckboxBound === 'true') return;

    list.dataset.brandCheckboxBound = 'true';

    list.addEventListener('change', function (evt) {
      if (evt.target.type !== 'checkbox') return;

      if (evt.target.checked) {
        pendingScrollToPartType = true;
        applyBrandSelectionCollapse(filter);
        return;
      }

      if (getSelectedBrandCheckboxes(filter).length === 0) {
        var searchInput = filter.querySelector('.js-brand-filter-search');
        applyBrandSelectionCollapse(filter);

        if (searchInput) {
          filterBrandList(searchInput);
        }
      }
    });
  }

  function bindSearchInput(input) {
    if (input.dataset.brandSearchBound === 'true') return;
    input.dataset.brandSearchBound = 'true';

    input.addEventListener('input', function () {
      var filter = input.closest('.filter');

      if (filter && filter.id) {
        savedQueries[filter.id] = input.value;
      }

      filterBrandList(input);
    });

    input.addEventListener('keydown', function (evt) {
      if (evt.key !== 'Escape') return;

      input.value = '';

      var filter = input.closest('.filter');
      if (filter && filter.id) {
        savedQueries[filter.id] = '';
      }

      filterBrandList(input);
    });
  }

  function initBrandFilter(filter) {
    if (!isBrandFilter(filter)) return;

    bindBrandCheckbox(filter);
    applyBrandSelectionCollapse(filter);

    var searchInput = filter.querySelector('.js-brand-filter-search');
    if (searchInput && getSelectedBrandCheckboxes(filter).length === 0) {
      if (filter.id && savedQueries[filter.id]) {
        searchInput.value = savedQueries[filter.id];
      }

      filterBrandList(searchInput);
    }
  }

  function init(root) {
    var scope = root || document;

    scope.querySelectorAll('.filter[data-filter-kind="brand"]').forEach(function (filter) {
      initBrandFilter(filter);
    });

    scope.querySelectorAll('.js-brand-filter-search').forEach(function (input) {
      bindSearchInput(input);
    });

    if (pendingScrollToPartType) {
      pendingScrollToPartType = false;
      scrollToPartTypeFilter();
    }
  }

  function saveQueries(form) {
    if (!form) return;

    form.querySelectorAll('.js-brand-filter-search').forEach(function (input) {
      var filter = input.closest('.filter');

      if (filter && filter.id) {
        savedQueries[filter.id] = input.value;
      }
    });
  }

  window.FacetBrandSearch = {
    init: init,
    saveQueries: saveQueries
  };

  document.addEventListener('DOMContentLoaded', function () {
    init(document);
  });

  document.addEventListener('on:facet-filters:updated', function () {
    init(document.getElementById('facets') || document);
  });
})();
